<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import resize from "@/mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
      // required: true
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    options: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.options);
    },
    getIndicator() {
      let newStr = JSON.parse(JSON.stringify(this.options.indicator));
      let arr = [];
      for (let i in newStr) {
        arr.push(newStr[i]);
      }
      return arr
      
    },
    setOptions({ value }={}) {
      this.chart.setOption({
        radar: [
          {
            indicator: this.getIndicator(),
            center: ["50%", "55%"], // 位置
            radius: 50, //大小
            startAngle: 90, // 雷达图的旋转偏移量
            splitNumber: 4,
            shape: "line",
            nameGap: 5,
            name: {
              formatter: "{value}",
              textStyle: {
                color: "rgba(255, 255, 255, 0.85)", // 文字颜色
                fontSize: 13,
              },
            },
            splitArea: {
              areaStyle: {
                color: ["#20253A", "#2A2F43", "#34394C", "#3D4254"],
                //圆环颜色
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(128, 128, 128, 0.1)", // 五角内部的连接线颜色
              },
            },
            splitLine: {
              lineStyle: {
                color: "#595959", // 每个区域的边框颜色
              },
            },
          },
        ],
        series: [
          {
            // name: '雷达图',
            type: "radar",
            itemStyle: {
              emphasis: {
                // color: 各异,
                lineStyle: {
                  width: 4,
                },
              },
            },
            data: [
              {
                // value: [200, 400, 600, 800, 1000],   // 排序从顶部→左→左下角→右下角→右侧
                value: value,
                lineStyle: {
                  // 五点连接线的样式。
                  normal: {
                    opacity: 1, // 图形透明度,
                    color: "#1F6AFB",
                  },
                },
                itemStyle: {
                  // 单个拐点标志的样式设置。
                  normal: {
                    borderColor: "#2276FC",
                    // 拐点的描边颜色。[ default: '#000' ]
                    borderWidth: 3,
                    // 拐点的描边宽度，默认不描边。[ default: 0 ]
                  },
                },
                areaStyle: {
                  normal: {
                    color: "rgba(34, 118, 252, 0.5)", // 五点连接后形成的区域颜色: 透明色
                  },
                },
              },
            ],
          },
        ],
      });
    },
  },
};
</script>